module.exports = __webpack_public_path__ + "img/not-pic01.61b2e918.png";